import axios from 'axios';
import * as types from '../constants/actionTypes';

export const base_url = 'https://api.v2.raceresults360.com/v2/race';
// const base_url = 'https://wr9pern1x5.execute-api.us-east-1.amazonaws.com/Development/race';


export function addAPIKeyToHeader(getState) {

  const accountId = getState().rr360.accountId || 'rr360'; //TODO - remove this

  return {headers: {'x-api-key':`rr360-api-key-account-${accountId}`}};

}

export function setIsMobile(isMobile) {

  return function(dispatch) {

    dispatch({
      type: types.SET_MOBILE,
      isMobile
    });
  }

}


export function switchRace(newRaceId) {

  return function (dispatch, getState) {
    dispatch({
      type: types.SWITCH_RACE
    });

    if (newRaceId) {
      getRaceDetails(newRaceId)(dispatch, getState);
    }

  }

}

export function clearSearch() {
  return function (dispatch) {
    dispatch({
      type: types.CLEAR_SEARCH_RESULTS
    });
  }
}

export function getRaces(search = null) {
  return function(dispatch, getState) {

    axios.get(`${base_url}${search ? `?search=${search}` : ''}`, addAPIKeyToHeader(getState))
      .then((result) => {
        dispatch({
          type: types.GET_RACES,
          races: result.data
        });
      });
  };
}

export function getRaceDetails(raceId) {
  return function (dispatch, getState) {
    // console.log('Getting Race Details');
    axios.get(`${base_url}/${raceId}`, addAPIKeyToHeader(getState))
      .then((result) => {
        dispatch({
          type: types.GET_RACE_DETAIL,
          raceDetail: result.data
        });
      })
      .catch((err) => {
        if (err.response.status === 403) {
          dispatch({
            type: types.UNAUTHORIZED
          });
        }
      });
  };
}

export function selectEvent(eventId) {
  return function (dispatch) {
    dispatch({
      type: types.SELECT_EVENT,
      eventId
    });
  };
}

export function getLeaderboard() {
  return function (dispatch, getState) {

    const raceId = getState().rr360.raceDetail.race_id;
    const eventId = getState().rr360.eventId || '';

    axios.get(`${base_url}/${raceId}/${eventId}/leaderboard?leaderboard=men`, addAPIKeyToHeader(getState))
      .then((result) => {
        dispatch({
          type: types.GET_LEADERBOARD_MEN,
          leadersMen: result.data
        });
      });
    axios.get(`${base_url}/${raceId}/${eventId}/leaderboard?leaderboard=women`, addAPIKeyToHeader(getState))
      .then((result) => {
        dispatch({
          type: types.GET_LEADERBOARD_WOMEN,
          leadersWomen: result.data
        });
      });

  };
}

export function toggleFavorite(leader, fav) {
  return function (dispatch, getState) {



    let favorites = Object.assign([], getState().rr360.favorites);
    if (fav) {
      favorites.push(leader);
    } else {
      favorites = favorites.filter(x => x.$KEY !== leader.$KEY);
    }

    localStorage.setItem(getState().rr360.raceDetail.race_id + '::favorites', JSON.stringify(favorites));

    dispatch({
      type: types.TOGGLE_FAVORITE,
      favorites
    });

  };
}

export function syncFavorites(raceId) {
  return function (dispatch) {

    const favorites = JSON.parse(localStorage.getItem(raceId + '::favorites'));
    dispatch({
      type: types.TOGGLE_FAVORITE,
      favorites
    });
  };
}

export function refreshFavorites() {
  return function(dispatch, getState) {
    // TODO - do something here
  }
}

export function getResults(page = 0, raceIdParam = null) {
  return function (dispatch, getState) {
    const eventId = getState().rr360.eventId || '';
    const raceId = raceIdParam || getState().rr360.raceDetail.race_id;

    const urlParams = {start: page*30};

    axios.get(`${base_url}/${raceId}/${eventId}/results`, {params: urlParams, ...addAPIKeyToHeader(getState)})
      .then((result) => {
        dispatch({
          type: types.GET_RESULTS,
          results: result.data.results,
          resultsTotal: result.data.total,
          resultsPage: result.data.start/30
        });
      });
  };
}

export function refreshResults() {
  return function (dispatch, getState) {

    getResults()(dispatch, getState);

  };
}

export function refreshLeaderboard() {
  return function (dispatch, getState) {
    getLeaderboard()(dispatch, getState);
  }
}

export function getRunnerResults(raceId, eventId, bib) {
  return function (dispatch, getState) {

    dispatch({
      type: types.GET_RUNNER_RESULTS,
      runnerResult: null
    });
    const eventIdParam = eventId || '';
    axios.get(`${base_url}/${raceId}/${eventIdParam}/${bib}`, addAPIKeyToHeader(getState))
      .then((result) => {
        dispatch({
          type: types.GET_RUNNER_RESULTS,
          runnerResult: result.data
        });
      });

  };
}

// TODO - update this
export function submitQuestion(question) {
  return function (dispatch, getState) {
    const raceId = getState().rr360.raceDetail.race_id;
    const urlParams = Object.assign({race_id: raceId, page: 'questions', pot: ''}, question);

    axios.get('http://www.raceresults360.com/widget/json.php', {params: urlParams, ...addAPIKeyToHeader(getState)})
      .then((result) => {
        // console.log(result.data);
        dispatch({
          type: types.SUBMIT_QUESTION,
          submitQuestionSuccess: result.data.success
        })

      });
  };
}

export function performSearch(search = null, div = null, page = 0, eventId = null, raceId = null) {
  return function (dispatch, getState) {
    const raceIdParam = raceId || getState().rr360.raceDetail.race_id;
    let eventIdParam = eventId || getState().rr360.eventId;
    const searchParam = search || getState().rr360.search;
    const divParam = div  || getState().rr360.div;

    eventIdParam = eventIdParam || '';
    const urlParams = {search: searchParam, start: page*30};

    let divPart = '';
    if (divParam) {
      divPart = divParam === 'ALL' ? '' : `/${divParam}`;
    }

    axios.get(`${base_url}/${raceIdParam}/${eventIdParam}/results${divPart}`, {params: urlParams, ...addAPIKeyToHeader(getState)})
      .then((result) => {
        dispatch({
          type: types.SEARCH_RESULTS,
          search,
          div: divParam,
          searchResults: result.data.results,
          searchResultsTotal: result.data.total,
          searchResultsPage: result.data.start / 30,
          start: result.data.start
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/race.js